import { render, staticRenderFns } from "./shipmentsdispatched.vue?vue&type=template&id=d5790adc&scoped=true"
import script from "./shipmentsdispatched.vue?vue&type=script&lang=js"
export * from "./shipmentsdispatched.vue?vue&type=script&lang=js"
import style0 from "./shipmentsdispatched.vue?vue&type=style&index=0&id=d5790adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5790adc",
  null
  
)

export default component.exports